module.exports = __webpack_public_path__ + "static/media/employee-engagement-software-banner.d3670389.png";